<template>
  <div class="sidebar">
    <!-- Header: Logo institucional -->
    <div class="sidebar-header">
      <div class="university-brand">
        <div class="uni-logo">
          <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="uni-icon">
            <rect x="1" y="1" width="30" height="30" rx="4" stroke="white" stroke-width="1.5"/>
            <path d="M8 22V14l8-6 8 6v8" stroke="white" stroke-width="1.5" stroke-linejoin="round"/>
            <rect x="13" y="16" width="6" height="6" stroke="white" stroke-width="1.5"/>
          </svg>
        </div>
        <div class="uni-text">
          <span class="uni-name-small">MUNAD</span>
          <span class="uni-name-main">JGMUN</span>
        </div>
        <div class="simon-divider">|</div>
        <div class="simon-text">SICE</div>
      </div>
    </div>

    <!-- Perfil — mismo origen que el dashboard -->
    <div class="profile-section">
      <div class="avatar-wrapper">
        <img v-if="delegateData && delegateData.userPhotoUrl" :src="delegateData.userPhotoUrl" alt="avatar" class="avatar-img" />
        <div v-else class="avatar-placeholder">
          <i class="far fa-circle-user"></i>
        </div>
      </div>
      <div class="profile-info">
        <div class="profile-name">
          {{ (delegateData && delegateData.name) || (isPresident ? "Presidente" : "Delegado") }}
        </div>
        <div class="profile-role">
          {{ isPresident ? "Presidente" : "Delegado" }}
        </div>
        <div v-if="commissionData && commissionData.name" class="profile-commission">
          {{ commissionData.name }}
        </div>
      </div>
    </div>

    <!-- Navegación -->
    <nav class="sidebar-nav">
      <ul class="nav-list">

        <li class="nav-item" :class="{ active: currentRoute === '/dashboard' }" @click="navigate('/dashboard')">
          <i class="far fa-compass nav-icon"></i>
          <span class="nav-label">Inicio</span>
        </li>

        <li v-if="!isPresident" class="nav-item" :class="{ active: currentRoute === '/files' }" @click="navigate('/files')">
          <i class="far fa-file nav-icon"></i>
          <span class="nav-label">Mis archivos</span>
        </li>

        <li class="nav-item" :class="{ active: currentRoute === '/evidence' }" @click="navigate('/evidence')">
          <i class="far fa-clipboard nav-icon"></i>
          <span class="nav-label">Evidencias</span>
        </li>
        <li class="nav-item" v-if="isPresident" :class="{ active: currentRoute === '/sentencing' }" @click="navigate('/sentencing')">
       <i class="fas fa-gavel nav-icon"></i>
          <span class="nav-label">Sentencias</span>
        </li>
        <li class="nav-item" :class="{ active: currentRoute === '/notifications' }" @click="navigate('/notifications')">
          <i class="far fa-bell nav-icon"></i>
          <span class="nav-label">Notificaciones</span>
        </li>

      </ul>
    </nav>

    <!-- Footer -->
    <div class="sidebar-footer">
      <button class="logout-btn" @click="changeAuthContext">
        <i class="far fa-share-from-square"></i>
        <span>Cerrar sesión</span>
      </button>
    </div>
  </div>
</template>

<script>
import { clearAuthContext } from "@/authContext";

export default {
  name: "Sidebar",

  computed: {
    authContext() {
      return (
        this.$delegateStore.state.authContext || {
          cohort: "",
          commissionId: "",
          delegateId: "",
        }
      );
    },
    isPresident() {
      return this.authContext.role === "president";
    },
    delegateData() {
      return this.$delegateStore.state.delegateData;
    },
    commissionData() {
      return this.$delegateStore.state.commissionData;
    },
    currentRoute() {
      return this.$route ? this.$route.path : "";
    },
  },

  methods: {
    navigate(path) {
      if (this.$router && this.$route.path !== path) {
        this.$router.push(path).catch(() => {});
      }
    },
    changeAuthContext() {
      clearAuthContext();
      this.$delegateStore.resetDelegateState();
      this.$router.replace("/auth");
    },
  },
};
</script>

<style scoped>
/* Requiere Font Awesome en index.html:
   <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"> */

.sidebar {
  width: 260px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #23233a;
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,0.1) transparent;
}
.sidebar::-webkit-scrollbar { width: 4px; }
.sidebar::-webkit-scrollbar-track { background: transparent; }
.sidebar::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.12); border-radius: 2px; }

/* Header */
.sidebar-header {
  padding: 18px 16px 14px;
  border-bottom: 1px solid rgba(255,255,255,0.07);
}
.university-brand {
  display: flex;
  align-items: center;
  gap: 8px;
}
.uni-icon { width: 36px; height: 36px; }
.uni-text { display: flex; flex-direction: column; line-height: 1.1; }
.uni-name-small { font-size: 9px; color: rgba(255,255,255,0.75); letter-spacing: 0.02em; }
.uni-name-main { font-size: 13px; color: #fff; font-weight: 600; }
.simon-divider { color: rgba(255,255,255,0.3); font-size: 20px; font-weight: 200; line-height: 1; margin: 0 2px; }
.simon-text { font-size: 22px; font-weight: 800; color: #fff; letter-spacing: 0.08em; }

/* Profile */
.profile-section {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 16px 16px;
  border-bottom: 1px solid rgba(255,255,255,0.07);
}
.avatar-wrapper {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  background: rgba(255,255,255,0.08);
  border: 2px solid rgba(255,255,255,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar-img { width: 100%; height: 100%; object-fit: cover; }
.avatar-placeholder { display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; }
.avatar-placeholder .far { font-size: 36px; color: rgba(255,255,255,0.4); line-height: 1; }
.profile-name { font-size: 13.5px; font-weight: 600; color: #fff; line-height: 1.3; word-break: break-word; }
.profile-role { font-size: 12px; color: #6b9ef7; font-style: italic; font-weight: 500; margin-top: 2px; }
.profile-commission { font-size: 11px; color: rgba(255,255,255,0.45); margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

/* Nav */
.sidebar-nav { flex: 1; padding: 8px 0; }
.nav-list { list-style: none; margin: 0; padding: 0; }
.nav-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 11px 18px;
  cursor: pointer;
  color: rgba(255,255,255,0.68);
  transition: background 0.15s ease, color 0.15s ease;
  position: relative;
  user-select: none;
}
.nav-item:hover { background: rgba(255,255,255,0.06); color: #fff; }
.nav-item.active { background: rgba(255,255,255,0.09); color: #fff; }
.nav-item.active::before {
  content: '';
  position: absolute;
  left: 0; top: 5px; bottom: 5px;
  width: 3px;
  background: #6b9ef7;
  border-radius: 0 2px 2px 0;
}
.nav-icon { font-size: 16px; width: 20px; text-align: center; flex-shrink: 0; }
.nav-label { font-size: 13.5px; font-weight: 400; letter-spacing: 0.01em; }

/* Footer */
.sidebar-footer { padding: 14px 16px; border-top: 1px solid rgba(255,255,255,0.07); }
.logout-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  background: none;
  border: none;
  color: rgba(255,255,255,0.5);
  font-size: 13px;
  cursor: pointer;
  padding: 8px 4px;
  border-radius: 6px;
  transition: color 0.15s, background 0.15s;
  font-family: inherit;
}
.logout-btn:hover { color: #fff; background: rgba(255,255,255,0.06); }
.logout-btn .far { font-size: 15px; }
</style>